import React from 'react'
import { 
  Button, 
  Grid, 
  makeStyles 
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { AutorizacionesCard } from '../UI/AutorizacionesCard'
import { setActiveStep, setShowForm } from '../../../actions/autorizaciones/Autorizaciones';
import { GruposLaboratorio } from '../../turnos/recepcionDiaria/laboratorio/steps/GruposLaboratorio';
import { PracticasLaboratorioTabla } from '../../turnos/recepcionDiaria/laboratorio/steps/PracticasLaboratorioTabla';
import { ESPECIALIDADES, OBRAS_SOCIALES } from '../../../utils/constants';

const useStyles = makeStyles((theme) => ({
  rootBotonera: {
    marginLeft: "auto",
    marginRight: "auto",
    width: "70%",
  },
  botonera: {
      marginTop: 5,
      marginBottom: 20,
      paddingBottom: 13
  },
}));

export const AutorizacionesPracticasLaboratorio = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  
  const { showForm = {}, activeStep } = useSelector(
    (state) => state.autorizaciones
  );
  
  const handleBack = () => {
    if(showForm)
      dispatch( setShowForm(false) );
    else
      dispatch( setActiveStep(activeStep - 1) );
  };

  const handleNext = () => {
    if(!showForm)
      document.querySelector(`#btnSubmitLaboratorioStep2`).click();        
    else
      document.querySelector(`#btnSubmitLaboratorioStep3`).click();        
  };

  return (
    <AutorizacionesCard width={"55%"}>
      {!showForm ? (
        <GruposLaboratorio ingresoCab={true} />
      ) : (
        <PracticasLaboratorioTabla 
          ingresoCab={true}
          idObraSocial={OBRAS_SOCIALES.OSPEDYC} 
          parametros={ {idEspecialidad: ESPECIALIDADES.LABORATORIO} }
        />
      )}
    <div className={classes.rootBotonera}>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
        className={classes.botonera}
      >
        <Button
          variant="contained"
          onClick={handleBack}
          color="secondary"
        >
          Anterior
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleNext}
        >
          Siguiente
        </Button>
      </Grid>
    </div>
  </AutorizacionesCard>
)}
